import { render } from "./wizardNuevoAsegurado.vue?vue&type=template&id=44df0ea9"
import script from "./wizardNuevoAsegurado.vue?vue&type=script&lang=js"
export * from "./wizardNuevoAsegurado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__